/**
 * @generated SignedSource<<6dbea2908d1bd771c3efd1d677f9fed6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRelatedItemsSection_item$data = ReadonlyArray<{
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"FavoritesProvider_item" | "SharedItemTile_item" | "useSbSharedItemTracking_item">;
  readonly " $fragmentType": "SharedRelatedItemsSection_item";
}>;
export type SharedRelatedItemsSection_item$key = ReadonlyArray<{
  readonly " $data"?: SharedRelatedItemsSection_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRelatedItemsSection_item">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "showSeller"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SharedRelatedItemsSection_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesProvider_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSbSharedItemTracking_item"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller"
        }
      ],
      "kind": "FragmentSpread",
      "name": "SharedItemTile_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "c3822df10d86096970754ed94fa0232d";

export default node;
